import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { IntroTeaser } from "../../IntroTeaser";
import { useSetSupportWebp, useGet360Data, useSetDefaultUrlsMedia, } from "../../../hooks";
export var Viewer360Component = memo(function () {
    useGet360Data();
    useSetDefaultUrlsMedia();
    useSetSupportWebp();
    return _jsx(IntroTeaser, {});
});
